import { all } from "axios";

export default {
  startsWith: "Starts with",
  contains: "Contains",
  notContains: "Not contains",
  endsWith: "Ends with",
  equals: "Equals",
  notEquals: "Not equals",
  noFilter: "No Filter",
  lt: "Less than",
  lte: "Less than or equal to",
  gt: "Greater than",
  gte: "Greater than or equal to",
  dateIs: "Date is",
  dateIsNot: "Date is not",
  dateBefore: "Date is before",
  dateAfter: "Date is after",
  custom: "Custom",
  clear: "Clear",
  apply: "Apply",
  matchAll: "Match All",
  matchAny: "Match Any",
  addRule: "Add Rule",
  removeRule: "Remove Rule",
  accept: "Yes",
  reject: "No",
  choose: "Choose",
  upload: "Upload",
  cancel: "Cancel",
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  monthNamesShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  today: "Today",
  weekHeader: "Wk",
  firstDayOfWeek: 0,
  dateFormat: "yyyy-mm-dd",
  weak: "Weak",
  medium: "Medium",
  strong: "Strong",
  passwordPrompt: "Enter a password",
  emptyFilterMessage: "No results found",
  emptyMessage: "No available options",
  uploadedFiles: "Uploaded files",
  uploadFailed: "Upload Failed",
  maxFileLimit: "Max file limit of ${limit} exceeded!",
  aria: {
    trueLabel: "True",
    falseLabel: "False",
    nullLabel: "Not Selected",
    pageLabel: "Page",
    firstPageLabel: "First Page",
    lastPageLabel: "Last Page",
    nextPageLabel: "Next Page",
    previousPageLabel: "Previous Page",
    selectLabel: "Select",
    unselectLabel: "Unselect",
    expandLabel: "Expand",
    collapseLabel: "Collapse",
  },
  validations: {
    required: "Value is required.",
    undefined: "Value is required.",
    email: "Value is not a valid email address",
    minLength: "This field should be at least ${min} characters long",
    maxLength: "The maximum length allowed is ${max}",
    minValue: "The minimum value allowed is ${min}",
    maxValue: "The maximum value allowed is ${max}",
    numeric: "Value must be numeric",
    ipAddress: "The value is not a valid IP address",
    sameAs: "The value must be equal to the ${otherName} value",
  },
  company: "Company",
  company_name: "Company Name",
  visitant: "Visitor",
  visitant_name: "Visitor Name",
  visitant_email: "Visitor Email",
  visitant_phone: "Visitor Phone",
  phone: "Phone",
  subject: "Subject",
  visit_to: "Visit To",
  select_to: "Select Who to Visit",
  date_to_visit: "Date of Visit",
  time_to_visit: "Time of Visit",
  identification: "Identification",
  save: "Save",
  info_not_permitted:
    "Access is for visit only, working inside the plant is not allowed with this access permission.",
  show_security_rules: "Show security rules",
  visitors: "Visitors",
  employees: "Employees",
  welcomeTitle: "WELCOME!",
  welcomeMessage: "Welcome message",
  securityRules: "Security rules",
  securityRulesTitle: "GENERAL RULES FOR SAFETY, HYGIENE, AND ENVIRONMENT",
  securityRule1:
    "Smoking is prohibited inside the facility. Smoking is allowed only in designated area outside of the building.",
  securityRule2: "Wear a visible ID at all times within the facilities.",
  securityRule3:
    "Entering under the influence of alcohol, narcotics, or any substance that alters mental or sensory faculties is prohibited.",
  securityRule4:
    "Do not take photographs or videos inside the facilities without authorization from HSE or HR.",
  securityRule5:
    "Removing tools, materials, or equipment without authorization is prohibited.",
  securityRule6: "Respect and obey all safety signs.",
  securityRule7:
    "The minimum personal protective equipment (PPE) required is: safety shoes, safety glasses, earplugs, and a reflective vest (contractors/suppliers/visitors). Additional PPE may be required depending on the type of work.",
  securityRule8: "Visitors with health issues are not allowed.",
  securityRule9: "Visitors with disabilities are not allowed.",
  securityRule10:
    "Visitors with behavioral problems or those who do not meet the following requirements are not allowed:",
  goodPracticesTitle: "GOOD MANUFACTURING PRACTICES AND DRESS CODE",
  goodPractices1:
    "The use of inappropriate clothing such as sleeveless tops, low-cut shirts, shorts, or ripped/torn pants is prohibited. Pants must fully cover the legs.",
  goodPractices2:
    "The use of open-toe or high-heeled shoes in operational areas is prohibited.",
  goodPractices3:
    "Food and beverages may only be consumed in designated areas.",
  goodPractices4: "Keep the work area clean and organized.",
  goodPractices5:
    "Keep hair short or tied back, and do not wear chains, rings, bracelets, or other objects that could get caught in operational areas.",
  prohibitedItemsTitle: "PROHIBITED ITEMS",
  prohibitedItems1: "Alcoholic beverages.",
  prohibitedItems2: "Narcotics or controlled substances.",
  prohibitedItems3: "Explosives.",
  prohibitedItems4: "Cigarettes or tobacco products.",
  prohibitedItems5: "Firearms or ammunition.",
  prohibitedItems6: "Cameras or video devices without authorization.",
  prohibitedItems7:
    "Hazardous materials without a Safety Data Sheet and HSE authorization.",
  prohibitedItems8: "Removable blades.",
  prohibitedItems9:
    "Internal combustion engines without approved emission control.",
  close: "Close",
  vendors: "Vendors",
  employees: "Employees",
  visitants: "Visitants",
  visitant_email: "Visitor Email",
  visitant_phone: "Visitor Phone",
  drag_file: "Drag and drop the file here",
  back: "Back",
  usernameOrEmail: "Username or Email",
  password: "Password",
  rememberMe: "Remember Me",
  forgotpassword: "Did you forget your password?",
  login: "Sign In",
  vendorsAccess: "Vendors Access",
  employeesAccess: "Colaborators Access",
  visitantsAccess: "Visitants Access",
  home: "Home",
  welcomeTo: "Welcome to",
  resumeTwoDays: "Resume of the last two days",
  toDate: "To Date",
  rounds: "Rounds",
  findingsInTransit: "Findings in Transit",
  findingsOnPatrol: "Findings on Patrol",
  incidents: "Incidents",
  incident: "Incident",
  findings: "Findings",
  reports: "Reports",
  monthlyIncidentsReport: "Monthly incidents report",
  selectMonth: "Select Month",
  startDate: "Start Date",
  endDate: "End Date",
  month: "Month",
  year: "Year",
  download: "Download",
  selectRound: "Select Round",
  checkListReport: "Check list report",
  all: "All",
  positive: "Positive",
  neutral: "Neutral",
  negative: "Negative",
  roundLogReport: "Round log report",
  onlyCompleted: "Only completed",
  onlyUncompleted: "Only uncompleted",
  onlyWithoutExecuted: "Only without finished",
  opened: "Opened",
  closed: "Closed",
  roundRoute: "Round Route",
  tags: "Tags",
  tag: "Tag",
  tasks: "Tasks",
  users: "Users",
  administration: "Administration",
  permissions: "Permissions",
  roles: "Roles",
  search: "Search",
  export: "Export",
  finishedRounds: "Finished Rounds",
  OnGoingRounds: "On Going Rounds",
  route: "Route",
  realizedBy: "Realized By",
  occurred: "Occurred",
  finished: "Finalized",
  duration: "Duration",
  accomplishment: "Accomplishment",
  view: "View",
  noRecordsFound: "No records found",
  of: "of",
  patrols: "Patrols",
  rejectAccessRequestTitle: "Reject Access Request",
  accessrequests: "Access Requests",
  newAccessRequest: "New Access Request",
  accessLog: "Access Log",
  accessvip: "Access VIP",
  accesslogvip: "Access Log VIP",
  Accesses: "Accesses",
  accountDetails: "Account Details",
  id: "ID",
  name: "Name",
  lastname: "Lastname",
  username: "Username",
  email: "Email",
  mobile: "Mobile",
  accountEdit: "Account Edit",
  changePassword: "Change Password",
  loading: "Loading...",
  report: "Report",
  enterName: "Enter Name",
  oldpassword: "Current Password",
  newpassword: "New Password",
  confirmpassword: "Confirm Password",
  profileImage: "Profile Image",
  enterLastname: "Enter Lastname",
  enterUsername: "Enter Username",
  enterEmail: "Enter Email",
  enterMobile: "Enter Mobile",
  requestCannotBeCompleted: "Request cannot be completed",
  all_rights_reserved: "All rights reserved",
  myAccount: "My Account",
  logout: "Logout",
  welcome: "Welcome!",
  accesslog: "Access Log",
  actions: "Actions",
  downloadPDF: "Download PDF",
  addNew: "Add New",
  enterLabel: "Enter Label",
  send: "Send",
  edit: "Edit",
  delete: "Delete",
  update: "Update",
  requester: "Requester",
  select_a_value: "Select a value",
  vendor: "Vendor",
  subject: "Subject",
  enterSubject: "Enter Subject",
  visitMessageRequest:
    "The access is for visit only, working inside the plant is not allowed with this access permission.",
  visit_to: "Person to visit",
  scheduledVisitDate: "Scheduled Visit Date",
  identification: "Identification",
  documentation: "Documentation",
  employee: "Employee",
  fullNameVisitor: "Full Name Visitor",
  visitor: "Visitor",
  enterPhone: "Enter Phone",
  status: "Status",
  priority: "Priority",
  addAccessrequest: "Add Access Request",
  expirationDate: "Expiration Date",
  kanban: "Kanban",
  newRequest: "New Request",
  requests: "Requests",
  accessRequestStatus: "Access Request Status",
  date: "Date",
  visit_time: "Visit Time",
  comment: "Comment",
  documentationQ: "Documentation?",
  noRequireRevision: "No revision\nrequired",
  documentationCorrect: "Documentation\ncorrect",
  requireRevision: "Revision\nrequired",
  acceptedQ: "Accepted?",
  yes: "Yes",
  no: "No",
  Documentación: "Documentation",
  Validación: "Validation",
  Rechazado: "Rejected",
  Aceptado: "Acepted",
  Completado: "Completed",
  Invitado: "Guest",
  add: "Add",
  host: "Host",
  enterCompany: "Enter Company",
  select_date: "Select Date",
  taxId: "Tax ID",
  vendorStatus: "Vendor Status",
  repse: "REPSE",
  address: "Address",
  requesterDetails: "Requester Details",
  deleteRecord: "Delete Record",
  confirmRecordDeletion: "Are you sure you want to delete this record?",
  confirmAcceptVisit: "Are you sure you want to accept this visit?",
  acceptVisit: "Accept Visit",
  acceptedSuccessfully: "Accepted Successfully",
  date_hour: "Date and Hour",
  type: "Type",
  securityGuard: "Security Guard",
  accessNotes: "Access Notes",
  records: "Records",
  notes: "Notes",
  gaveAccess: "Gave Access",
  images: "Images",
  qrCode: "QR Code",
  viewQr: "View QR",
  notAvailable: "Not Available",
  enterTaxId: "Enter Tax ID",
  checking: "Checking...",
  enterAddress: "Enter Address",
  formsRequired: "Forms Required",
  formValidationError: "Form Validation Error",
  formValidationMsg: "Please complete the form",
  createRecord: "Create Record",
  createRecordSuccess: "Record created successfully",
  category: "Category",
  updateRecord: "Update Record",
  updateSuccess: "Record updated successfully",
  bitacora: "Control log",
  select_a_status: "Select a status",
  nss: "SSN",
  enterNss: "Enter SSN",
  employeeDetails: "Employee Details",
  forms: "Forms",
  writeHere: "Write here",
  carrier: "Carrier",
  carrierrequests: "Carrier Access Requests",
  rampsDashboards: "Ramps Dashboards",
  carrier_accesslog: "Carrier Access Log",
  rampsScreen: "Ramps Screen",
  settings: "Settings",
  vendorsCategories: "Vendors Categories",
  departments: "Departments",
  statusRequests: "Status of Requests",
  priorities: "Priorities",
  statusUsers: "Status of Users",
  statusVendors: "Status of Vendors",
  statusRepse: "Status of REPSE",
  print: "Print",
  pdf: "PDF",
  excel: "Excel",
  csv: "CSV",
  historyChanges: "History of Changes",
  noAuditsRecords: "No audit records found",
  change: "Change",
  unknown: "Unknown",
  inProgress: "In Progress",
  created: "Created",
  updated: "Updated",
  deleted: "Deleted",
  event: "Event",
  findingReport: "Finding Report",
  findingType: "Finding Type",
  inTransit: "In Transit",
  onPatrol: "On Patrol",
  updating: "Updating...",
  changeToClosed: "Change to Closed",
  changeToOpened: "Change to Opened",
  reportedBy: "Reported By",
  description: "Description",
  noImagesAttached: "No images attached",
  finishedAt: "Finished At",
  round: "Round",
  duration: "Duration",
  tagsCompleted: "Tags Completed",
  successFinished: "Finished successfully",
  earlyFinished: "Finished early",
  notFinished: "Not finished",
  folio: "Folio",
  doneBy: "Done By",
  hour: "Hour",
  comments: "Comments",
  user: "User",
  addComment: "Add Comment",
  area: "Area",
  responsableOfService: "Responsable of Service",
  itWasReported: "It was reported",
  severity: "Severity",
  shortDescription: "Short Description",
  incidentReport: "Incident Report",
  reportDate: "Report Date",
  ocurrenceDate: "Ocurrence Date",
  reportedBy: "Reported By",
  deleteSelected: "Delete Selected",
  addTag: "Add Tag",
  latitude: "Latitude",
  longitude: "Longitude",
  altitude: "Altitude",
  selectLocation: "Select Location",
  location: "Location",
  drag_marker: "Drag the marker to change the location",
  subcategory: "Subcategory",
  group: "Group",
  keyword: "Keyword",
  task: "Task",
  enterPassword: "Enter Password",
  confirmPassword: "Confirm Password",
  department: "Department",
  role: "Role",
  securityRulesHeader: "Security Rules",
  welcomeVip: "WELCOME",
  seeYouSoonVip: "SEE YOU SOON",
  accessQrCodeQuestion: "Do you want to register access of this QR code?",
  accessQrCodeError: "Error registering access",
  cameraNotFound: "Camera not found",
  cameraNotAccess: "Camera not access",
  toggleCamera: "Toggle Camera",
  confirm: "Confirm",
  appPatrol: "Patrol App",
  appGuard: "Guard App",
  appCarrier: "Kiosko App",
  modulePatrol: "Patrol Dashboard",
  moduleGuard: "Guard Dashboard",
  moduleCarrier: "Carrier Dashboard",
  patrol: "Patrols",
  guard: "Guard",
  carrier: "Kiosko",
  accessInsideBuilding: "Access Inside Building",
  requestsToApprove: "Requests to Approve",
  approvedRequests: "Requests Accepted",
  vendorsList: "Vendors Directory",
  monthlyRequests: "Monthly Requests",
  exporting: "Exporting...",
  findingOnPatrol: "Findings on Patrol",
  findingInTransit: "Findings in Transit",
  occurrenceDate: "Occurrence Date",
  quizTitle: "Quiz",
  answerQuiz: "Answer Quiz",
  notProhibited1: "Food and Beverage",
  notProhibited2: "Celphone and electronic devices",
  notGoodPractices1: "Inappropriate and casual clothing",
  question1: "What is the first security rule?",
  question2: "What item is prohibited?",
  question3: "What is not a good practice?",
  errorQuiz: "Answer at least 2 correctly to continue.",
  vehicles: "Vehicles",
  plates: "Plates",
  model: "Model",
  circulation_card: "Circulation Card",
  vehicle_secure: "Car insurance",
  enterPlates: "Enter Plates",
  enterModel: "Enter Model",
  select_year: "Select Year",
  fk_vendor: "Vendor",
  vehicle: "Vehicle",
  tools: "Tools",
  computers: "Computers",
  serial_number: "Serial Number",
  enterSerialNumber: "Enter Serial Number",
  computer_equipment: "Computer Equipment",
  employee_name: "Employee Name",
  categoryServiceMessage:
    "If the employee category is Contractor you will upload the files of *Insurance* as well as a vigent *Security and Hygiene Course* and *Patrimonial Course*.",
  categoryContractorMessage:
    "If the employee category is Specialized Services you will upload the files of *Insurance* and *ISO 14001* as well as a vigent *Security and Hygiene Course* and *Patrimonial Course*.",
  categoryVendorMessage:
    "If the vendor category is Vendor you don't need to upload any file.",
  computer_id: "Computers",
  tools_id: "Tools",
  image: "Image",
  captcha_advisement:
    "Verify that you are not a robot. Robots cannot access the plant.",
  captcha_expiration_advisement:
    "After validating the captcha you have 5 minutes to make the request for visit.",
  needs_assistance_short: "Requires assistance",
  needs_assistance:
    "Do you have any condition or disability that requires assistance?",
  assistance_description: "What kind of assistance do you need?",
  acknowledge_policy_agreement_first_part:
    "I have read and agree to abide by the guidelines presented in the ",
  acknowledge_policy_agreement_anchor:
    "Policy on Labor Equality and Non-Discrimination, the Code of Ethics, and the Protocol for addressing complaints of discrimination, violence, harassment, and bullying",
  acknowledge_policy_agreement_last_part:
    ", as well as to accept the consequences that may apply in case of non-compliance",
  colaborators: "Colaborators",
  equality_title: "EQUAL EMPLOYMENT OPPORTUNITY AND NON-DISCRIMINATION",
  equality_intro:
    "At GlobalVoIP, we reinforce our commitment to zero tolerance for acts of violence, discrimination, harassment, and bullying.",
  equality_invitation:
    "To access our facilities, we invite you to read and review:",
  equality_policy:
    "Our Equal Employment Opportunity and Non-Discrimination Policy",
  ethics_code: "The Code of Ethics",
  complaint_protocol:
    "Our Complaint Protocol for Cases of Discrimination, Violence, Harassment, and Bullying",
  view_document: "View document",

  acknowledge_policy_agreement: "You must accept the guidelines",
  select_to_hour: "Seleccione una hora",
};
